import React from "react";

let launch = "hard";

const teaserState = {
  launch,
};

export const TeaserStateContext = React.createContext(teaserState);

export const TeaserProvider: React.FunctionComponent = ({ children }) => {
  console.log("TeaserProvider", { launch });
  return (
    <TeaserStateContext.Provider value={{ launch }}>
      {children}
    </TeaserStateContext.Provider>
  );
};
